import { proxy } from 'valtio'

interface AppMenuStateType {
  opened: boolean;
  /** When set, AppMenu opens directly to this view. Reset to undefined after use. */
  initialView?: 'helpCenter' | 'contactSupport';
}
export const AppMenuState = proxy<AppMenuStateType>({
  opened: false,
})

export const closeAppMenu = () => {
  AppMenuState.opened = false
}

export const openAppMenuToHelpCenter = () => {
  AppMenuState.initialView = 'contactSupport'
  AppMenuState.opened = true
}
